'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { publicExternshipCatalogQueryOptions } from '@/app/(auth)/_partials/portfolio-arrival/_api/use-public-externship-catalog';

/**
 * Warms the public catalog for a matcher arrival.
 *
 * The matcher layout is code-split and reads the catalog once it mounts; the pressed program's live
 * id, and so `redirect_url`, only exist after that read. Rendered from the switcher, this starts the
 * same query while the layout's chunk is still downloading, so by the time the form can be clicked
 * the id is normally already known. React Query dedupes it with the layout's own read. Renders nothing.
 */
export function MatcherCatalogPrefetch() {
  const $ = _c(3);
  const queryClient = useQueryClient();
  let t0;
  let t1;
  if ($[0] !== queryClient) {
    t0 = () => {
      queryClient.prefetchQuery(publicExternshipCatalogQueryOptions()).catch(_temp);
    };
    t1 = [queryClient];
    $[0] = queryClient;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  return null;
}
function _temp() {}